import Permission from '@common/components/permission';
import { EPermissions } from '@common/definitions';
import React from 'react';
import { Trans } from 'react-i18next';
import Icon from '@common/components/icon';
import { Moment } from 'moment';
import { useDispatch } from 'react-redux';
import { initialize } from 'redux-form';
import { TableDropdown } from '@common/components/table';

const UploadSchedule = ({ currentWeek, setIsUploadModalVisible }:
  { currentWeek: Moment, setIsUploadModalVisible: () => void }) => {
  const dispatch = useDispatch();
  const handleAddSchedule = (schedule: { date: string; value: string }) => {
    dispatch(
      initialize('upload-schedule', {
        week: schedule.date,
        function_id: schedule.value || 'network',
        schedule: null,
      })
    );
    setIsUploadModalVisible();
  };
  return (
    <Permission
      name={[
          EPermissions.NETWORK_FUNCTION_MEMBERSHIPS_SCHEDULES_CREATE,
          EPermissions.NETWORK_SCHEDULES_CREATE,
        ]}
    >
      <TableDropdown.Item
        onClick={() => handleAddSchedule({
              date: currentWeek.format('YYYY-MM-DD'),
              value: 'network',
            })}
      >
        <div role="button" className="flex items-center space-x-2">
          <Icon type="calendar_today" />
          <Trans i18nKey="schedules:container_upload_button" />
        </div>
      </TableDropdown.Item>
    </Permission>
  );
};

export default UploadSchedule;
